namespace Matrix.Data {
    export interface CreditRatingForm {
        RatingFactor: Serenity.IntegerEditor;
        SpLong: Serenity.StringEditor;
        SpShort: Serenity.StringEditor;
        MoodysLong: Serenity.StringEditor;
        MoodysShort: Serenity.StringEditor;
        FitchLong: Serenity.StringEditor;
        FitchShort: Serenity.StringEditor;
        DefaultSortOrder: Serenity.IntegerEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class CreditRatingForm extends Serenity.PrefixedContext {
        static formKey = 'Data.CreditRating';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CreditRatingForm.init)  {
                CreditRatingForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(CreditRatingForm, [
                    'RatingFactor', w0,
                    'SpLong', w1,
                    'SpShort', w1,
                    'MoodysLong', w1,
                    'MoodysShort', w1,
                    'FitchLong', w1,
                    'FitchShort', w1,
                    'DefaultSortOrder', w0,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3,
                    'Version', w2
                ]);
            }
        }
    }
}
